"use client";
import { useLogout } from "@repo/lib/hooks/logout";

const SignOut = ({ isUnauthorized }) => {
  useLogout({ isUnauthorized });
  return (
    <>
      <div className="fixed top-0 h-[66px] w-full bg-black md:h-[80px]"></div>
      <div className="min-h-96"></div>
    </>
  );
};

export default SignOut;
